import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  archivedUserAdapter,
  ArchivedUserState,
  USERS_FEATURE_KEY,
  usersAdapter,
  UsersPartialState,
  UserState,
} from './users.reducer';

// Lookup the 'Users' feature state managed by NgRx
export const getUsersState = createFeatureSelector<
  UsersPartialState,
  UserState
>(USERS_FEATURE_KEY);

const { selectAll, selectEntities } = usersAdapter.getSelectors();
const archivedUserSelector = archivedUserAdapter.getSelectors();

export const getSelectedUser = createSelector(
  getUsersState,
  (state: UserState) => state.userEntityDetails
);

export const getUsersLoaded = createSelector(
  getUsersState,
  (state: UserState) => state.loaded
);

export const getUsersError = createSelector(
  getUsersState,
  (state: UserState) => state.error
);

export const findUserAccount = createSelector(
  getUsersState,
  (state: UserState) => state.createUserIdentified
);

export const getAllUsers = createSelector(getUsersState, (state: UserState) =>
  selectAll(state)
);

export const getAllArchivedUsers = createSelector(
  getUsersState,
  (state: UserState) => archivedUserSelector.selectAll(state.archivedUsers)
);

export const getUsersEntities = createSelector(
  getUsersState,
  (state: UserState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getUsersState,
  (state: UserState) => state.selectedId
);

export const getSelected = createSelector(
  getUsersEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);

export const getPagination = createSelector(
  getUsersState,
  (state: UserState) => state.pagination
);
